import moment from 'moment';
import PartAlertLevel from '@/common/PartAlertLevel';

export const recalculatePartProperties = function (update) {
  if (update.newPartProperties.deliverydate === '') {
    update.newPartProperties.deliverydate = '0000-01-01';
  }

  var startdate;
  if (update.undoStrategy === 'undo') {
    // No auto recalculations on undo...
  } else if (update.newPartProperties.startdate) {
    startdate = moment(update.newPartProperties.startdate);
    if (startdate.isoWeekday() >= 6) {
      startdate.add(8 - startdate.isoWeekday(), 'day');
    }
    update.newPartProperties.expectedDonedate = startdate
      .isoAddWeekdaysFromSet(update.updatePart.time - 1, [1, 2, 3, 4, 5])
      .format('YYYY-MM-DD');
    update.newPartProperties.controldate = update.newPartProperties.expectedDonedate;
    update.newPartProperties.calendarTime =
      moment(update.newPartProperties.expectedDonedate).diff(update.newPartProperties.startdate, 'day') + 1;
  } else if (update.newPartProperties.hasOwnProperty('time')) {
    if (update.newPartProperties.time <= 0) {
      update.newPartProperties.time = 1;
    }
    startdate = moment(update.updatePart.startdate);
    if (startdate.isoWeekday() >= 6) {
      startdate.add(8 - startdate.isoWeekday(), 'day');
    }
    update.newPartProperties.expectedDonedate = startdate
      .isoAddWeekdaysFromSet(update.newPartProperties.time - 1, [1, 2, 3, 4, 5])
      .format('YYYY-MM-DD');
    update.newPartProperties.controldate = update.newPartProperties.expectedDonedate;
    update.newPartProperties.calendarTime =
      moment(update.newPartProperties.expectedDonedate).diff(update.updatePart.startdate, 'day') + 1;
  } else if (update.newPartProperties.expectedDonedate) {
    startdate = moment(update.updatePart.startdate);
    var donedate = moment(update.newPartProperties.expectedDonedate);
    if (startdate > donedate) {
      startdate = moment(donedate);
      update.newPartProperties.startdate = startdate.format('YYYY-MM-DD');
    }
    update.newPartProperties.calendarTime = donedate.diff(startdate, 'day') + 1;
    update.newPartProperties.controldate = update.newPartProperties.expectedDonedate;
    update.newPartProperties.time = moment().isoWeekdayCalc(startdate, donedate, [1, 2, 3, 4, 5]);
    while (update.newPartProperties.time === 0) {
      startdate = startdate.add(-1, 'day');
      update.newPartProperties.startdate = startdate.format('YYYY-MM-DD');
      update.newPartProperties.time = moment().isoWeekdayCalc(startdate, donedate, [1, 2, 3, 4, 5]);
    }
  }
};

export const isLateDelivery = (part) => {
  return part.deliverydate > '0001-01-01' && moment(part.deliverydate).isBefore(moment()) && !part.deliveryFulfilled;
};

export const isLate = (part) => {
  return (
    moment(part.expectedDonedate).isBefore(moment()) &&
    moment(part.controldate).isBefore(moment()) &&
    !part.controlFulfilled
  );
};

export const isPostPoned = (part) => {
  return (
    moment(part.expectedDonedate).isBefore(moment()) &&
    moment(part.controldate).isAfter(moment()) &&
    !part.controlFulfilled
  );
};

export const isUnconfirmed = (part) => {
  return (
    moment(part.controldate).isBefore(moment()) &&
    moment(part.expectedDonedate).isAfter(moment()) &&
    !part.controlFulfilled
  );
};

export const partAlert = (part) => {
  if (isLateDelivery(part)) {
    return PartAlertLevel.Error;
  }
  if (isPostPoned(part)) {
    return PartAlertLevel.Warning;
  }
  if (isLate(part)) {
    return PartAlertLevel.Error;
  }
  if (isUnconfirmed(part)) {
    return PartAlertLevel.Warning;
  }
  return PartAlertLevel.Ok;
};

export const partAlertReason = (part) => {
  if (!part) {
    return '';
  }
  if (isLateDelivery(part)) {
    return 'deliverydate';
  }
  if (isLate(part)) {
    return 'expectedDonedate';
  }
  if (isUnconfirmed(part)) {
    return 'controldate';
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/common/partHelpers.js